
/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  FeaturesResponse,
  FiltersResponse,
  SearchResponse,
  SimpleError,
  UpdateSearchTranslationPreferenceRequest,
  ValidationError,
} from '../models';
import {
    FeaturesResponseFromJSON,
    FeaturesResponseToJSON,
    FiltersResponseFromJSON,
    FiltersResponseToJSON,
    SearchResponseFromJSON,
    SearchResponseToJSON,
    SimpleErrorFromJSON,
    SimpleErrorToJSON,
    UpdateSearchTranslationPreferenceRequestFromJSON,
    UpdateSearchTranslationPreferenceRequestToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface RetrieveAvailableFiltersRequest {
    q: string;
    p?: number;
    minPrice?: number;
    maxPrice?: number;
    badge?: Array<RetrieveAvailableFiltersBadgeEnum>;
    exp?: Array<RetrieveAvailableFiltersExpEnum>;
    speciality?: Array<string>;
    category?: Array<string>;
    lang?: Array<string>;
    businessSector?: Array<string>;
    remoteAllowed?: boolean;
    remoteEuropa?: boolean;
    lat?: number;
    lon?: number;
    city?: string;
    location?: string;
    countryCode?: string;
    administrativeAreaLevel1Code?: string;
    administrativeAreaLevel2Code?: string;
    administrativeAreaLevel3Code?: string;
    administrativeAreaLevel4Code?: string;
    excludedProfiles?: Array<string>;
    fallback?: boolean;
    searchid?: string;
    searchOrigin?: RetrieveAvailableFiltersSearchOriginEnum;
    adminFilter?: Array<RetrieveAvailableFiltersAdminFilterEnum>;
    locale?: string;
}

export interface RetrieveFeaturesRequest {
    q: string;
    p?: number;
}

export interface SearchProfilesRequest {
    q: string;
    p?: number;
    minPrice?: number;
    maxPrice?: number;
    badge?: Array<SearchProfilesBadgeEnum>;
    exp?: Array<SearchProfilesExpEnum>;
    speciality?: Array<string>;
    category?: Array<string>;
    lang?: Array<string>;
    businessSector?: Array<string>;
    remoteAllowed?: boolean;
    remoteEuropa?: boolean;
    lat?: number;
    lon?: number;
    city?: string;
    location?: string;
    countryCode?: string;
    administrativeAreaLevel1Code?: string;
    administrativeAreaLevel2Code?: string;
    administrativeAreaLevel3Code?: string;
    administrativeAreaLevel4Code?: string;
    excludedProfiles?: Array<string>;
    fallback?: boolean;
    searchid?: string;
    searchOrigin?: SearchProfilesSearchOriginEnum;
    adminFilter?: Array<SearchProfilesAdminFilterEnum>;
    locale?: string;
}

export interface UpdateProfileTranslationPreferenceRequest {
    updateSearchTranslationPreferenceRequest: UpdateSearchTranslationPreferenceRequest;
}

/**
 * 
 */
export class SearchProfilesApi extends runtime.BaseAPI {

    /**
     * Retrieve filters for Profiles
          */
    async retrieveAvailableFiltersRaw(requestParameters: RetrieveAvailableFiltersRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FiltersResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling retrieveAvailableFilters().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['p'] != null) {
            queryParameters['p'] = requestParameters['p'];
        }

        if (requestParameters['minPrice'] != null) {
            queryParameters['minPrice'] = requestParameters['minPrice'];
        }

        if (requestParameters['maxPrice'] != null) {
            queryParameters['maxPrice'] = requestParameters['maxPrice'];
        }

        if (requestParameters['badge'] != null) {
            queryParameters['badge'] = requestParameters['badge'];
        }

        if (requestParameters['exp'] != null) {
            queryParameters['exp'] = requestParameters['exp'];
        }

        if (requestParameters['speciality'] != null) {
            queryParameters['speciality'] = requestParameters['speciality'];
        }

        if (requestParameters['category'] != null) {
            queryParameters['category'] = requestParameters['category'];
        }

        if (requestParameters['lang'] != null) {
            queryParameters['lang'] = requestParameters['lang'];
        }

        if (requestParameters['businessSector'] != null) {
            queryParameters['businessSector'] = requestParameters['businessSector'];
        }

        if (requestParameters['remoteAllowed'] != null) {
            queryParameters['remoteAllowed'] = requestParameters['remoteAllowed'];
        }

        if (requestParameters['remoteEuropa'] != null) {
            queryParameters['remoteEuropa'] = requestParameters['remoteEuropa'];
        }

        if (requestParameters['lat'] != null) {
            queryParameters['lat'] = requestParameters['lat'];
        }

        if (requestParameters['lon'] != null) {
            queryParameters['lon'] = requestParameters['lon'];
        }

        if (requestParameters['city'] != null) {
            queryParameters['city'] = requestParameters['city'];
        }

        if (requestParameters['location'] != null) {
            queryParameters['location'] = requestParameters['location'];
        }

        if (requestParameters['countryCode'] != null) {
            queryParameters['countryCode'] = requestParameters['countryCode'];
        }

        if (requestParameters['administrativeAreaLevel1Code'] != null) {
            queryParameters['administrativeAreaLevel1Code'] = requestParameters['administrativeAreaLevel1Code'];
        }

        if (requestParameters['administrativeAreaLevel2Code'] != null) {
            queryParameters['administrativeAreaLevel2Code'] = requestParameters['administrativeAreaLevel2Code'];
        }

        if (requestParameters['administrativeAreaLevel3Code'] != null) {
            queryParameters['administrativeAreaLevel3Code'] = requestParameters['administrativeAreaLevel3Code'];
        }

        if (requestParameters['administrativeAreaLevel4Code'] != null) {
            queryParameters['administrativeAreaLevel4Code'] = requestParameters['administrativeAreaLevel4Code'];
        }

        if (requestParameters['excludedProfiles'] != null) {
            queryParameters['excludedProfiles'] = requestParameters['excludedProfiles'];
        }

        if (requestParameters['fallback'] != null) {
            queryParameters['fallback'] = requestParameters['fallback'];
        }

        if (requestParameters['searchid'] != null) {
            queryParameters['searchid'] = requestParameters['searchid'];
        }

        if (requestParameters['searchOrigin'] != null) {
            queryParameters['searchOrigin'] = requestParameters['searchOrigin'];
        }

        if (requestParameters['adminFilter'] != null) {
            queryParameters['adminFilter'] = requestParameters['adminFilter'];
        }

        if (requestParameters['locale'] != null) {
            queryParameters['locale'] = requestParameters['locale'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FiltersResponse>({
            path: `/search/api/profiles/filters`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FiltersResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Retrieve filters for Profiles
          */
    async retrieveAvailableFilters(requestParameters: RetrieveAvailableFiltersRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FiltersResponse> {
        const response = await this.retrieveAvailableFiltersRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Retrieve features for user search
          */
    async retrieveFeaturesRaw(requestParameters: RetrieveFeaturesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FeaturesResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling retrieveFeatures().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['p'] != null) {
            queryParameters['p'] = requestParameters['p'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FeaturesResponse>({
            path: `/search/api/profiles/features`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FeaturesResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Retrieve features for user search
          */
    async retrieveFeatures(requestParameters: RetrieveFeaturesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FeaturesResponse> {
        const response = await this.retrieveFeaturesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Search existing profiles depending on query parameters.  Available searches: - Location search - Remote search on the country linked to the malt domain - Remote search on the configured countries (Europa remote search) - Global domain search (only on malt.com) 
     * Search for Profiles
          */
    async searchProfilesRaw(requestParameters: SearchProfilesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SearchResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling searchProfiles().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['p'] != null) {
            queryParameters['p'] = requestParameters['p'];
        }

        if (requestParameters['minPrice'] != null) {
            queryParameters['minPrice'] = requestParameters['minPrice'];
        }

        if (requestParameters['maxPrice'] != null) {
            queryParameters['maxPrice'] = requestParameters['maxPrice'];
        }

        if (requestParameters['badge'] != null) {
            queryParameters['badge'] = requestParameters['badge'];
        }

        if (requestParameters['exp'] != null) {
            queryParameters['exp'] = requestParameters['exp'];
        }

        if (requestParameters['speciality'] != null) {
            queryParameters['speciality'] = requestParameters['speciality'];
        }

        if (requestParameters['category'] != null) {
            queryParameters['category'] = requestParameters['category'];
        }

        if (requestParameters['lang'] != null) {
            queryParameters['lang'] = requestParameters['lang'];
        }

        if (requestParameters['businessSector'] != null) {
            queryParameters['businessSector'] = requestParameters['businessSector'];
        }

        if (requestParameters['remoteAllowed'] != null) {
            queryParameters['remoteAllowed'] = requestParameters['remoteAllowed'];
        }

        if (requestParameters['remoteEuropa'] != null) {
            queryParameters['remoteEuropa'] = requestParameters['remoteEuropa'];
        }

        if (requestParameters['lat'] != null) {
            queryParameters['lat'] = requestParameters['lat'];
        }

        if (requestParameters['lon'] != null) {
            queryParameters['lon'] = requestParameters['lon'];
        }

        if (requestParameters['city'] != null) {
            queryParameters['city'] = requestParameters['city'];
        }

        if (requestParameters['location'] != null) {
            queryParameters['location'] = requestParameters['location'];
        }

        if (requestParameters['countryCode'] != null) {
            queryParameters['countryCode'] = requestParameters['countryCode'];
        }

        if (requestParameters['administrativeAreaLevel1Code'] != null) {
            queryParameters['administrativeAreaLevel1Code'] = requestParameters['administrativeAreaLevel1Code'];
        }

        if (requestParameters['administrativeAreaLevel2Code'] != null) {
            queryParameters['administrativeAreaLevel2Code'] = requestParameters['administrativeAreaLevel2Code'];
        }

        if (requestParameters['administrativeAreaLevel3Code'] != null) {
            queryParameters['administrativeAreaLevel3Code'] = requestParameters['administrativeAreaLevel3Code'];
        }

        if (requestParameters['administrativeAreaLevel4Code'] != null) {
            queryParameters['administrativeAreaLevel4Code'] = requestParameters['administrativeAreaLevel4Code'];
        }

        if (requestParameters['excludedProfiles'] != null) {
            queryParameters['excludedProfiles'] = requestParameters['excludedProfiles'];
        }

        if (requestParameters['fallback'] != null) {
            queryParameters['fallback'] = requestParameters['fallback'];
        }

        if (requestParameters['searchid'] != null) {
            queryParameters['searchid'] = requestParameters['searchid'];
        }

        if (requestParameters['searchOrigin'] != null) {
            queryParameters['searchOrigin'] = requestParameters['searchOrigin'];
        }

        if (requestParameters['adminFilter'] != null) {
            queryParameters['adminFilter'] = requestParameters['adminFilter'];
        }

        if (requestParameters['locale'] != null) {
            queryParameters['locale'] = requestParameters['locale'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<SearchResponse>({
            path: `/search/api/profiles`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=SearchResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Search existing profiles depending on query parameters.  Available searches: - Location search - Remote search on the country linked to the malt domain - Remote search on the configured countries (Europa remote search) - Global domain search (only on malt.com) 
     * Search for Profiles
          */
    async searchProfiles(requestParameters: SearchProfilesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SearchResponse> {
        const response = await this.searchProfilesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Update Profile Translation for Europa search
          */
    async updateProfileTranslationPreferenceRaw(requestParameters: UpdateProfileTranslationPreferenceRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['updateSearchTranslationPreferenceRequest'] == null) {
            throw new runtime.RequiredError(
                'updateSearchTranslationPreferenceRequest',
                'Required parameter "updateSearchTranslationPreferenceRequest" was null or undefined when calling updateProfileTranslationPreference().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/search/api/profiles/features/translationPreference`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSearchTranslationPreferenceRequestToJSON(requestParameters['updateSearchTranslationPreferenceRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update Profile Translation for Europa search
          */
    async updateProfileTranslationPreference(requestParameters: UpdateProfileTranslationPreferenceRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateProfileTranslationPreferenceRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const RetrieveAvailableFiltersBadgeEnum = {
    SuperMalter: 'SUPER_MALTER'
} as const;
export type RetrieveAvailableFiltersBadgeEnum = typeof RetrieveAvailableFiltersBadgeEnum[keyof typeof RetrieveAvailableFiltersBadgeEnum];
/**
 * @export
 */
export const RetrieveAvailableFiltersExpEnum = {
    Entry: 'ENTRY',
    Intermediate: 'INTERMEDIATE',
    Expert: 'EXPERT',
    ExpertPlus: 'EXPERT_PLUS'
} as const;
export type RetrieveAvailableFiltersExpEnum = typeof RetrieveAvailableFiltersExpEnum[keyof typeof RetrieveAvailableFiltersExpEnum];
/**
 * @export
 */
export const RetrieveAvailableFiltersSearchOriginEnum = {
    Signup: 'SIGNUP'
} as const;
export type RetrieveAvailableFiltersSearchOriginEnum = typeof RetrieveAvailableFiltersSearchOriginEnum[keyof typeof RetrieveAvailableFiltersSearchOriginEnum];
/**
 * @export
 */
export const RetrieveAvailableFiltersAdminFilterEnum = {
    RecentlyModified: 'RECENTLY_MODIFIED'
} as const;
export type RetrieveAvailableFiltersAdminFilterEnum = typeof RetrieveAvailableFiltersAdminFilterEnum[keyof typeof RetrieveAvailableFiltersAdminFilterEnum];
/**
 * @export
 */
export const SearchProfilesBadgeEnum = {
    SuperMalter: 'SUPER_MALTER'
} as const;
export type SearchProfilesBadgeEnum = typeof SearchProfilesBadgeEnum[keyof typeof SearchProfilesBadgeEnum];
/**
 * @export
 */
export const SearchProfilesExpEnum = {
    Entry: 'ENTRY',
    Intermediate: 'INTERMEDIATE',
    Expert: 'EXPERT',
    ExpertPlus: 'EXPERT_PLUS'
} as const;
export type SearchProfilesExpEnum = typeof SearchProfilesExpEnum[keyof typeof SearchProfilesExpEnum];
/**
 * @export
 */
export const SearchProfilesSearchOriginEnum = {
    Signup: 'SIGNUP'
} as const;
export type SearchProfilesSearchOriginEnum = typeof SearchProfilesSearchOriginEnum[keyof typeof SearchProfilesSearchOriginEnum];
/**
 * @export
 */
export const SearchProfilesAdminFilterEnum = {
    RecentlyModified: 'RECENTLY_MODIFIED'
} as const;
export type SearchProfilesAdminFilterEnum = typeof SearchProfilesAdminFilterEnum[keyof typeof SearchProfilesAdminFilterEnum];
